export default __webpack_public_path__ + "static/media/remove.45126985.svg";